/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModelSettingsCredential } from './model-settings-credential';


export interface ModelSettingsOverride { 
    provider: string;
    id: string;
    /**
     * The saved key-source mode: \"platform\" runs on Convercus\'s models (Claude on Amazon Bedrock, EU regions only) under the flat monthly budget, \"dedicated\" on the same models with the program\'s own optional monthly limit and no key, \"byok\" on the program\'s own stored keys — the mode, not the model\'s tier, decides billing.
     */
    tier: ModelSettingsOverride.TierEnum;
    /**
     * Every provider credential stored for this program, one per provider — provider, owner, a 4-character hint, whether the key passed its live check, and the custom endpoint if one is set. Never the key itself. Empty when the program stores none. Customer keys are kept in every mode, so a platform or dedicated program may still list the keys it had for byok.
     */
    credentials: Array<ModelSettingsCredential>;
    /**
     * Deprecated — read `credentials` instead. The first stored credential\'s provider, kept for one release so clients written against the single-key shape keep working.
     */
    keyProvider?: string;
    /**
     * Deprecated — read `credentials[].hint`. Last 4 characters of the first stored key.
     */
    keyHint?: string;
    /**
     * Deprecated — read `credentials[].status`. \"verified\" when the first stored key passed the live provider check on save.
     */
    keyStatus?: ModelSettingsOverride.KeyStatusEnum;
    /**
     * The program\'s monthly limit in US dollars. Dedicated mode only, and only when one was set: absent means the spend is shown without a bar and the program is never blocked. Also absent here for callers without the dedicated permission (SUPER_ADMIN); the same cap is readable by every program reader as the budget\'s `limitUsd` on `GET /settings/budget`.
     */
    monthlyLimitUsd?: number;
    updatedAt: string;
}
export namespace ModelSettingsOverride {
    export type TierEnum = 'platform' | 'dedicated' | 'byok';
    export const TierEnum = {
        Platform: 'platform' as TierEnum,
        Dedicated: 'dedicated' as TierEnum,
        Byok: 'byok' as TierEnum
    };
    export type KeyStatusEnum = 'verified' | 'unverified';
    export const KeyStatusEnum = {
        Verified: 'verified' as KeyStatusEnum,
        Unverified: 'unverified' as KeyStatusEnum
    };
}


